define('v3/Common/Components/SortableColumnHeader/SortableColumnHeader.Component',[
	'knockout',
	'text!v3/Common/Components/SortableColumnHeader/SortableColumnHeader.Component.html',
	'v3/Common/Models/enums',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/Common/Bindings/Tooltip.Binding'
], function (ko, htmlString, enums) {
	function SortableColumnHeaderViewModel (params) {
		var self = this;

		self.extraHeaderComponent = params.extraHeaderComponent || null;
		self.shortTitleMode = ko.unwrap(params.shortTitleMode) || false;
		self.enums = enums;
		self.title = params.title;
		self.subtitle = params.subtitle;
		self.resizableTitle = params.resizableTitle;
		self.tooltip = params.tooltip;
		self.disableSorting = ko.computed(function () {
			return ko.unwrap(params.disableSorting) || false;
		});
		self.disableSortingCss = params.disableSortingCss;
		self.currentSortSetting = params.currentSortSetting;

		// string - column name
		var sortKey = ko.unwrap(params.sortkey);

		// string asc or desc
		self.selectedSortDirection = ko.observable(params.defaultSortDirection);

		self.hasSubtitle = function () {
			return !!ko.unwrap(self.subtitle);
		};

		var activeComputed = self.isActive = ko.computed(function () {
			return params.currentSortSetting() ? params.currentSortSetting().key === sortKey : false;
		});

		params.currentSortSetting.subscribe(function (newVal) {
			self.selectedSortDirection(newVal.direction);
		});

		function switchSortOrder () {
			if (self.selectedSortDirection() === enums.sortDirection.ascending) {
				self.selectedSortDirection(enums.sortDirection.descending);
			} else {
				self.selectedSortDirection(enums.sortDirection.ascending);
			}
		}

		self.sortClick = function () {
			if (params.currentSortSetting().key === sortKey) {
				switchSortOrder();
				var obj = params.currentSortSetting();
				obj.direction = self.selectedSortDirection();
				params.currentSortSetting(obj);
			} else {
				var newSetting = {
					key: sortKey,
					direction: params.defaultSortDirection
				};
				self.selectedSortDirection(params.defaultSortDirection);
				params.currentSortSetting(newSetting);
			}
		};

		self.dispose = function () {
			activeComputed.dispose();
		};
	}

	return { viewModel: SortableColumnHeaderViewModel, template: htmlString };
});

